<script lang="ts">
  import { cn } from '../lib/cn';
  import { fa } from '../i18n/fa';

  /**
   * A raised disc that breathes (ADR-060), for a wait with no shape to draw yet: the app starting, a
   * page's code on its way. A wait of a moment shows nothing (`.pulse-loader` fades in late).
   * `page` centres it in the screen; without it, it sits in its place.
   */
  let { label = fa.app.loading, page = false, small = false }: { label?: string; page?: boolean; small?: boolean } = $props();
</script>

<div role="status" aria-busy="true" class={cn('flex items-center justify-center', page ? 'min-h-[60dvh]' : 'py-6')}>
  <span class="sr-only">{label}</span>
  <span class={cn('pulse-loader', small && 'pulse-loader--small')} aria-hidden="true"></span>
</div>
